import React from 'react';
import { SubSteps } from '../SubSteps';
export const Swap = props => {
  return React.createElement(SubSteps, {
    start: props.start,
    unwrap: props.unwrap
  }, props.children);
};